import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(initReactI18next).use(LanguageDetector).use(Backend).init({
    debug: true,
    fallbackLng: 'en',
    returnobjects: true,
    ns: ['common', 'errors'],
    defaultNS: 'common',
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
        escapeValue: false, // React already does escaping
    },
});

export default i18n;